import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { ApiError, MessageService } from '../../../../../core';
import { Cliente } from '../../cliente';
import { isClienteRevisaoStatusPendente } from '../../cliente-revisao-status';
import { AtividadeChecklistItemComponent } from '../../../../atividade/checklist-item/atividade-checklist-item.component';
import { AtividadeClienteHttpService } from '../../../../atividade/services/atividade-cliente-http.service';

@Component({
    selector: 'sgt-cliente-revisao-confirmar',
    templateUrl: './cliente-revisao-confirmar.component.html',
    styleUrls: ['./cliente-revisao-confirmar.component.less']
})
export class ClienteRevisaoConfirmarComponent implements OnInit {
    @Input() entity: Cliente;
    isLoadingAtividade: boolean;

    @ViewChild('atividadeChecklistItem') atividadeChecklistItem: AtividadeChecklistItemComponent;

    constructor(private messageService: MessageService,
                private atividadeClienteHttpService: AtividadeClienteHttpService) { }

    ngOnInit() {
        if (this.isRevisaoPendente()) {
            this.loadAtividade();
        }
    }

    /** Verifica se o status da revisão do cliente é Pendente */
    isRevisaoPendente(): boolean {
        return isClienteRevisaoStatusPendente(this.entity?.revisaoStatus);
    }

    /** Obtem a atividade de revisão do cliente */
    private loadAtividade() {
        this.isLoadingAtividade = true;
        this.atividadeClienteHttpService.loadClienteRevisaoPendente(this.entity?.id)
            .subscribe(
                atividade => {
                    this.entity.atividadeRevisaoPendente = atividade;
                    this.isLoadingAtividade = false;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar a atividade de revisão deste cliente. Tente atualizar a página', error);
                    this.isLoadingAtividade = false;
                }
            );
    }

    /** Executa validações e métodos antes de salvar a confirmação da revisão do cliente */
    beforeSave() {
        // Checklist Itens
        this.atividadeChecklistItem?.beforeSave();
    }
}
